import {
  GetterTree, Module, MutationTree, ActionTree, ActionContext,
} from 'vuex'
import { RootState } from '..'
import { cms } from '@/cms'

export interface NewsletterState {
}

const newsletterState: NewsletterState = {
}

const mutations: MutationTree<NewsletterState> = {
}

const actions: ActionTree<NewsletterState, RootState> = {
  NEWSLETTER_SUBSCRIBE(ctx: ActionContext<NewsletterState, RootState>, p: { firstName: string, countryId: string, email: string, locale: string }) {
    return cms.newsletter.signup({
      email: p.email,
      name: p.firstName,
      country: p.countryId,
    })
  },
}

const getters: GetterTree<NewsletterState, RootState> = {
  newsletterIsEnabled: (): boolean => cms.newsletter.enabled,
  newsletterEnabledLocales: (): string[] => Object.keys(cms.campaign.newsletter.locales),
}

export const newsletterModule: Module<NewsletterState, RootState> = {
  state: newsletterState,
  mutations,
  actions,
  getters,
}
